import { render, staticRenderFns } from "./OrderClosed.vue?vue&type=template&id=48caa3a6&scoped=true"
import script from "./OrderClosed.vue?vue&type=script&lang=js"
export * from "./OrderClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caa3a6",
  null
  
)

export default component.exports